import React, { useEffect, useState } from 'react'

import { FaArrowLeft } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

import { loadRoutineCategories } from './routineAdapter'
import RoutinePlayer from './RoutinePlayer'
import { useStudents, useUser } from '../../../context'
import { Student } from '../../../types'
import { Section, PageContainer } from '../../_components'

import { RoutineEmpty, RoutineLoading, RoutineShell } from './styles'

import type { RoutineCategory } from './types'

const RoutinePage = () => {
  const navigate = useNavigate()
  const { user } = useUser()
  const { setActiveStudent, studentLogs } = useStudents()
  const [routines, setRoutines] = useState<RoutineCategory[] | null>(null)

  useEffect(() => {
    if (user) setActiveStudent(user as Student)
  }, [setActiveStudent, user])

  useEffect(() => {
    let cancelled = false
    if (!studentLogs) return
    loadRoutineCategories(studentLogs, (value) => {
      if (!cancelled) setRoutines(value)
    })
    return () => {
      cancelled = true
    }
  }, [studentLogs])

  const hasTracks = routines?.some((routine) => routine.content.length > 0)
  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1)
      return
    }
    navigate('/dashboard', { replace: true })
  }

  return (
    <PageContainer>
      <RoutineShell>
        <Section
          title="Tu Rutina-ah!"
          subtitle="Entrena tu voz a tu ritmo, con ejercicios preparados para ti."
          leadingAction={{
            icon: <FaArrowLeft aria-hidden="true" />,
            label: 'Volver a la pantalla anterior',
            onClick: goBack,
          }}
        >
          {!studentLogs || !routines ? (
            <RoutineLoading role="status">Cargando tu rutina…</RoutineLoading>
          ) : hasTracks ? (
            <RoutinePlayer routines={routines} />
          ) : (
            <RoutineEmpty>
              <strong>Aún no tienes una rutina cargada</strong>
              <span>Cuando tu profesor añada ejercicios, aparecerán aquí.</span>
            </RoutineEmpty>
          )}
        </Section>
      </RoutineShell>
    </PageContainer>
  )
}

export default RoutinePage
